<template>
  <div :aria-busy="state.status === 'loading'" class="lp-content-state">
    <UiSkeleton v-if="state.status === 'loading'" :lines="3" :block="block" />
    <UiErrorState v-else-if="state.status === 'error'" :title="$t('publicSite.sectionError')" :description="state.message || $t('publicSite.sectionErrorHelp')" @retry="$emit('retry')" />
    <UiEmptyState v-else-if="state.status === 'empty'" :title="$t('publicSite.sectionEmpty')" :description="$t('publicSite.sectionEmptyHelp')" />
    <slot v-else :data="state.data" />
  </div>
</template>
<script>
import { UiSkeleton, UiErrorState, UiEmptyState } from '@/components/ui';
export default { name: 'PublicContentState', components: { UiSkeleton, UiErrorState, UiEmptyState }, props: { state: { type: Object, required: true }, block: Boolean }, emits: ['retry'] };
</script>
